require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-accessibility-wrap-radio-buttons-in-a-fieldset-element-for-better-accessibility.json") })
        }
      }, "path---responsive-web-design-applied-accessibility-wrap-radio-buttons-in-a-fieldset-element-for-better-accessibility");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-accessibility-wrap-radio-buttons-in-a-fieldset-element-for-better-accessibility!./.cache/json/responsive-web-design-applied-accessibility-wrap-radio-buttons-in-a-fieldset-element-for-better-accessibility.json
// module id = 2532
// module chunks = 231608221292675